module.exports = __webpack_public_path__ + "static/media/fan_type.e331b229.png";